var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.07808 17.3099C13.6668 17.3099 17.3866 13.59 17.3866 9.0013C17.3866 4.41261 13.6668 0.692749 9.07808 0.692749C4.4894 0.692749 0.769531 4.41261 0.769531 9.0013C0.769531 13.59 4.4894 17.3099 9.07808 17.3099ZM8.8641 12.3618L13.48 6.82277L12.0616 5.64077L8.09286 10.4032L6.03816 8.34851L4.7326 9.65407L7.50212 12.4236L8.21693 13.1384L8.8641 12.3618Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedLight);
export default __webpack_public_path__ + "static/media/checkedLight.649c8e360d59acbd0e2b2eda125d776c.svg";
export { ForwardRef as ReactComponent };